import { render, staticRenderFns } from "./GoodsAddSymbol.vue?vue&type=template&id=19c3d2ef&"
import script from "./GoodsAddSymbol.vue?vue&type=script&lang=js&"
export * from "./GoodsAddSymbol.vue?vue&type=script&lang=js&"
import style0 from "./GoodsAddSymbol.vue?vue&type=style&index=0&id=19c3d2ef&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports